import { Button, ButtonProps } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { CheckCircle2, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState } from "react";

interface EligibilityButtonProps extends ButtonProps {
  variant?: "default" | "white";
  showIcon?: boolean;
  preserveFormData?: boolean;
}

const EligibilityButton = ({ 
  className, 
  variant = "default",
  showIcon = true,
  preserveFormData = false,
  ...props 
}: EligibilityButtonProps) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    try {
      setIsLoading(true);
      navigate("/eligibility", { 
        state: { 
          preserveFormData 
        } 
      });
    } catch (error) {
      console.error("Error handling eligibility check:", error);
      toast({
        title: "Error",
        description: "There was a problem accessing the eligibility check. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleClick}
      disabled={isLoading}
      className={cn(
        "transition-all duration-300 transform hover:-translate-y-1",
        variant === "white" ? "bg-white hover:bg-white/90 text-black" : "",
        className
      )}
      {...props}
    >
      {isLoading ? (
        <Loader2 className="w-5 h-5 mr-2 animate-spin" />
      ) : (
        showIcon && <CheckCircle2 className="w-5 h-5 mr-2" />
      )}
      {isLoading ? "Loading..." : "Check Your Eligibility"}
    </Button>
  );
};

export default EligibilityButton;